import { render, staticRenderFns } from "./SmallForm.vue?vue&type=template&id=7a1ee12a&scoped=true&"
import script from "./SmallForm.vue?vue&type=script&lang=js&"
export * from "./SmallForm.vue?vue&type=script&lang=js&"
import style0 from "./SmallForm.vue?vue&type=style&index=0&id=7a1ee12a&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a1ee12a",
  null
  
)

export default component.exports